import * as React from 'react';
import { AnyAction, Dispatch } from 'redux';
import { takeEvery } from 'redux-saga/effects';
import { EventTransition } from 'stageclip-common';

import { AddEventTransitionRequest } from '../api/definitions/addEventTransitionRequest';
import * as EntityNormalizers from '../api/normalizers/entityNormalizers';
import * as EventTransitionNormalizers from '../api/normalizers/eventTransitionNormalizers';
import { DataRequestActionTypes, InternalActionTypes } from '../constants/actionTypes';

import { RequestAction } from './allActions';
import { createAllEventActionsRequestedAction } from './eventActionsActions';
import { runApiRequest } from './saga/sagaActions';

export interface CreateAddEventTransitionRequestedAction extends RequestAction {
  type: DataRequestActionTypes.AddEventTransitionRequested;
  eventId: string;
  eventTransition: EventTransition;
}

export interface EventTransitionLoadedAction extends AnyAction {
  eventId: string;
  type: InternalActionTypes.EventTransitionLoaded;
  result: EntityNormalizers.NormalizedSingleEntity<EventTransitionNormalizers.NormalizedEventTransitions>;
}

export function createAddEventTransitionRequestedAction(
  eventId: string,
  eventTransition: EventTransition,
  component: React.Component,
  dispatch: Dispatch,
): CreateAddEventTransitionRequestedAction {
  return {
    dispatch,
    eventId,
    eventTransition,
    requestingComponent: component,
    type: DataRequestActionTypes.AddEventTransitionRequested,
  };
}

function createEventTransitionLoadedAction(
  eventId: string,
  result: EntityNormalizers.NormalizedSingleEntity<EventTransitionNormalizers.NormalizedEventTransitions>,
): EventTransitionLoadedAction {
  return {
    eventId,
    result,
    type: InternalActionTypes.EventTransitionLoaded,
  };
}

function* addEventTransition(action: CreateAddEventTransitionRequestedAction) {
  const request = new AddEventTransitionRequest(
    action.eventId,
    action.eventTransition,
    action.requestingComponent,
    action.dispatch,
  );
  yield runApiRequest(
    request,
    // @ts-ignore
    (result: EntityNormalizers.NormalizedSingleEntity<EventTransitionNormalizers.NormalizedEventTransitions>) => {
      action.dispatch(
        createAllEventActionsRequestedAction(action.eventId, action.requestingComponent, action.dispatch),
      );

      return createEventTransitionLoadedAction(action.eventId, result);
    },
  );
}

export function* addEventTransitionSaga() {
  yield takeEvery(DataRequestActionTypes.AddEventTransitionRequested, addEventTransition);
}
